import { useState, useCallback, useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import AssociationsSearchButton from './AssociationsSearchButton';
import AssociationsSortButtons from './AssociationsSortButtons';
import AssociationsSearchInput, { ANIMATION_DURATION } from './AssociationsSearchInput';
import { useCardContext } from '../../../context/CardContext';
import debounce from 'transmute/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AssociationsActionBar() {
  const {
    error,
    propertyDefinitions,
    onSearchQueryChange,
    currentSearchQuery,
    toObjectTypeId
  } = useCardContext();
  const [showSearchInput, setShowSearchInput] = useState(!!currentSearchQuery);
  const [searchValue, setSearchValue] = useState(currentSearchQuery || '');
  const debouncedSearch = useMemo(() => debounce(300, onSearchQueryChange), [onSearchQueryChange]);
  const handleSearchToggle = useCallback(() => {
    if (showSearchInput) {
      // Closing search
      onSearchQueryChange('');
      setTimeout(() => {
        setSearchValue('');
      }, ANIMATION_DURATION);
    }
    setShowSearchInput(!showSearchInput);
  }, [showSearchInput, onSearchQueryChange]);
  const handleSearchChange = useCallback(value => {
    setSearchValue(value);
    debouncedSearch(value);
  }, [debouncedSearch]);
  if (error || !propertyDefinitions || propertyDefinitions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    "data-test-id": "associations-action-bar",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "200",
      children: [/*#__PURE__*/_jsx(AssociationsSearchButton, {
        onSearchToggle: handleSearchToggle,
        showSearchInput: showSearchInput
      }), /*#__PURE__*/_jsx(AssociationsSortButtons, {
        propertyDefinitions: propertyDefinitions
      })]
    }), /*#__PURE__*/_jsx(AssociationsSearchInput, {
      showSearchInput: showSearchInput,
      value: searchValue,
      onChange: handleSearchChange,
      objectTypeId: toObjectTypeId
    })]
  });
}
export default AssociationsActionBar;